const state = {
    invoice_information: null
};

const getters = {
    getInvoiceInformation: state => {
        return state.invoice_information;
    }
};

const mutations = {
    setInvoiceInformation(state, invoice_information) {
        state.invoice_information = invoice_information;
    }
};

const actions = {
    saveInvoiceInformation(context, invoice_information) {
        context.commit("setInvoiceInformation", invoice_information);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
